/* Power of the Almond — custom cart drawer. Uses Shopify's Ajax Cart API. No dependencies. */
(function () {
  'use strict';
  if (window.LP2Cart) return;
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  function json(id, fb) { var el = doc.getElementById(id); if (!el) return fb; try { return JSON.parse(el.textContent); } catch (e) { return fb; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var CFG = json('lp2-cart-cfg', null); if (!CFG) return;
  CFG.gifts = (CFG.gifts || []).filter(Boolean); CFG.recs = (CFG.recs || []).filter(Boolean);
  CFG.loafProducts = (CFG.loafProducts || []).filter(Boolean);
  var FLAVORS = json('lp2-flavors', []);
  function money(c) { var v = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return (CFG.money || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v); }
  function img(u, w) { if (!u) return ''; return u.indexOf('?') > -1 ? u + '&width=' + w : u + '?width=' + w; }

  var root = $('[data-lp2-drawer]'); if (!root) return;
  var panel = $('.lp2-cart__panel', root), cart = null, lastFocus = null, busy = false, autoRecs = null;

  function api(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function isLoaf(it) { return CFG.loafProducts.indexOf(it.product_id) > -1; }
  function isGift(it) { return CFG.gifts.some(function (g) { return g.id === it.variant_id; }); }
  function loafCount(c) { return c.items.reduce(function (s, it) { return s + (isLoaf(it) ? it.quantity : 0); }, 0); }

  function counts(c) {
    $$('[data-lp2-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    doc.documentElement.classList.toggle('lp2-has-items', c.item_count > 0);
  }

  function render(c) {
    cart = c; counts(c);
    var n = c.item_count, loaves = loafCount(c), giftIn = c.items.some(isGift);
    $('[data-c-count]', root).textContent = n ? '(' + n + ')' : '';
    $('[data-c-empty]', root).hidden = n > 0;
    $('[data-c-foot]', root).hidden = n === 0;

    // free shipping bar
    var t = CFG.threshold || 0, tot = c.total_price, bar = $('[data-c-bar]', root);
    bar.hidden = !t || n === 0;
    if (t) {
      var left = t - tot;
      $('[data-c-bar-t]', root).innerHTML = left > 0 ? 'You\u2019re <b>' + money(left) + '</b> away from free shipping' : '<b>Free shipping unlocked</b>';
      $('[data-c-bar-f]', root).style.width = Math.min(100, Math.round(tot / t * 100)) + '%';
      bar.classList.toggle('is-done', left <= 0);
    }

    // line items
    $('[data-c-items]', root).innerHTML = c.items.map(function (it, i) {
      var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
      var free = it.final_line_price === 0 && it.original_line_price > 0;
      var disc = it.original_line_price > it.final_line_price;
      var gift = isGift(it), giftBad = gift && loaves < CFG.giftQty && !free;
      var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var title = String(it.product_title).split(' - ')[0]; if (!/pound cake/i.test(title) || /cookie|brownie/i.test(title)) title = title.replace(/\b(Low Carb Lifestyle|Low Carb|Keto|GF|Gluten[- ]Free)\s+/gi, '').trim();
      var fl = FLAVORS.filter(function (f) { return f.id === it.variant_id; })[0];
      return '<li class="lp2-line' + (free ? ' is-free' : '') + '" data-key="' + esc(it.key) + '">' +
        '<a class="lp2-line__img" href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 160)) + '" alt="" width="72" height="72" loading="lazy"></a>' +
        '<div class="lp2-line__info">' +
          '<p class="lp2-line__t">' + esc(v || title) + '</p>' +
          (v ? '<p class="lp2-line__s">' + esc(title) + '</p>' : '') +
          (fl && fl.net != null ? '<p class="lp2-line__carb">' + fl.net + 'g net carb' + (fl.net === 1 ? '' : 's') + ' / slice</p>' : '') +
          (plan ? '<p class="lp2-line__plan"><b>' + esc(plan.name) + '</b> · ' + esc(CFG.subNote) + '</p>' : '') +
          (free ? '<p class="lp2-line__gift">Free with ' + CFG.giftQty + '+ loaves</p>' : '') +
          (giftBad ? '<p class="lp2-line__warn">Add ' + (CFG.giftQty - loaves) + ' more loa' + (CFG.giftQty - loaves === 1 ? 'f' : 'ves') + ' to make these free</p>' : '') +
          '<div class="lp2-line__row">' +
            '<div class="lp2-qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="' + (it.quantity === 1 ? 'Remove ' : 'Decrease ') + esc(v || title) + '">' + (it.quantity === 1 ? '<svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true"><path d="M4 6h12M8 6V4h4v2M6 6l1 10h6l1-10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' : '&minus;') + '</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase ' + esc(v || title) + '">+</button>' +
            '</div>' +
            '<p class="lp2-line__p">' + (disc ? '<s>' + money(it.original_line_price) + '</s> ' : '') + (free ? '<b>FREE</b>' : money(it.final_line_price)) + '</p>' +
          '</div>' +
        '</div></li>';
    }).join('');

    // nudge: loaves short of the free-cookie / free-shipping box
    var nudge = $('[data-c-nudge]', root);
    var need = CFG.giftQty - loaves;
    if (loaves > 0 && need > 0) {
      var picks = FLAVORS.filter(function (f) { return f.available; }).slice(0, 8);
      nudge.innerHTML = '<p class="lp2-cart__nt">Add <b>' + need + ' more loa' + (need === 1 ? 'f' : 'ves') + '</b> for free cookies' + (t ? ' and free shipping' : '') + '</p>' +
        '<div class="lp2-cart__chips">' + picks.map(function (f) { return '<button type="button" class="lp2-cart__chip" data-add="' + f.id + '"><span>+ ' + esc(f.title) + '</span>' + (f.net != null ? '<small>' + f.net + 'g net</small>' : '') + '</button>'; }).join('') + '</div>';
      nudge.hidden = false;
    } else nudge.hidden = true;

    // gift picker
    var gw = $('[data-c-gift]', root);
    if (loaves >= CFG.giftQty && !giftIn && CFG.gifts.length) {
      gw.innerHTML = '<p class="lp2-cart__nt"><b>' + esc(CFG.giftTitle) + '</b></p><div class="lp2-cart__gifts">' + CFG.gifts.filter(function (g) { return g.available; }).map(function (g) {
        return '<div class="lp2-gift"><img src="' + esc(g.img) + '" alt="" width="56" height="56" loading="lazy"><div><p>' + esc(g.title) + '</p><p class="lp2-gift__p"><s>' + money(g.price) + '</s> <b>FREE</b></p></div><button type="button" class="lp2-btn lp2-btn--sm" data-add="' + g.id + '" data-gift>Add</button></div>';
      }).join('') + '</div>';
      gw.hidden = false;
    } else gw.hidden = true;

    renderRecs();
    $('[data-c-total]', root).textContent = money(c.total_price);
    // Itemized savings: one row per discount, named the way Shopify names it.
    var rows = {}, order = [], add = function (k, amt) { if (!amt) return; if (!rows[k]) { rows[k] = 0; order.push(k); } rows[k] += amt; };
    var dname = function (a) { var t = (a && (a.title || a.code)) || 'Discount'; if (/cookies/i.test(t) && /free/i.test(t)) return 'Free cookies (3+ loaves)'; if (a && a.type === 'discount_code') t = 'Code ' + t; return t + (a && a.value_type === 'percentage' && a.value ? ' (' + (+a.value) + '% off)' : ''); };
    c.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (al) { add(dname(al.discount_application), al.amount); }); });
    (c.cart_level_discount_applications || []).forEach(function (d) { add(dname(d), d.total_allocated_amount || 0); });
    var listed = order.reduce(function (s, k) { return s + rows[k]; }, 0);
    var other = c.original_total_price - c.total_price - listed; if (other > 0) add('Other savings', other);
    var dw = $('[data-c-disc]', root); dw.hidden = !order.length;
    dw.innerHTML = order.map(function (k) { return '<div><dt>' + esc(k) + '</dt><dd>\u2212' + money(rows[k]) + '</dd></div>'; }).join('');
    $('[data-c-sub]', root).hidden = !order.length; $('[data-c-sub-v]', root).textContent = money(c.original_total_price);
    $('[data-c-ship]', root).textContent = t && c.total_price >= t ? 'Shipping: free' : 'Shipping calculated at checkout';
    $('[data-c-checkout]', root).textContent = 'Checkout · ' + money(c.total_price);
  }

  function renderRecs() {
    var wrap = $('[data-c-recs]', root); if (!cart || !cart.item_count) { wrap.hidden = true; return; }
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var giftProducts = {}; CFG.gifts.forEach(function (g) { giftProducts[g.product] = 1; });
    var loaves = loafCount(cart);
    var list = CFG.recs.concat(autoRecs || []).filter(function (r, i, a) {
      if (inCart[r.product]) return false;
      if (loaves >= CFG.giftQty && giftProducts[r.product] && !cart.items.some(isGift)) return false; // they can get these free
      if (CFG.loafProducts.indexOf(r.product) > -1) return false;
      return a.findIndex(function (x) { return x.product === r.product; }) === i;
    }).slice(0, CFG.recLimit || 3);
    wrap.hidden = !list.length;
    $('[data-c-rail]', root).innerHTML = list.map(function (r) {
      return '<div class="lp2-rec"><img src="' + esc(r.img) + '" alt="" width="96" height="96" loading="lazy"><p class="lp2-rec__t">' + esc(r.title) + '</p><p class="lp2-rec__p">' + money(r.price) + '</p><button type="button" class="lp2-btn lp2-btn--sm lp2-btn--line" data-add="' + r.id + '">Add</button></div>';
    }).join('');
  }

  function loadAutoRecs() {
    if (!CFG.autoRecs || autoRecs || !cart || !cart.items.length) return;
    autoRecs = [];
    fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=6&intent=related').then(function (r) { return r.json(); }).then(function (j) {
      autoRecs = (j.products || []).filter(function (p) { return p.available && !/gift card/i.test(p.title); }).map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        return { id: v.id, product: p.id, title: String(p.title).split(' - ')[0], price: v.price, img: p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '' };
      });
      renderRecs();
    }).catch(function () {});
  }

  function refresh() { return api('/cart.js').then(function (c) { render(c); loadAutoRecs(); return c; }).catch(function () {}); }
  function err(m) { $('[data-c-err]', root).textContent = m || ''; }
  function change(key, q) {
    if (busy) return; busy = true; root.classList.add('is-busy'); err('');
    api('/cart/change.js', { id: key, quantity: Math.max(0, q) }).then(render).catch(function (e) { err((e && (e.description || e.message)) || 'Could not update your cart.'); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  function add(id, gift) {
    if (busy) return; busy = true; root.classList.add('is-busy'); err('');
    api('/cart/add.js', { items: [{ id: +id, quantity: 1, properties: { _source: gift ? 'lp2-free-cookie' : 'lp2-drawer' } }] }).then(refresh).catch(function (e) { err((e && (e.description || e.message)) || 'Could not add that item.'); })
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  function open(fetchFirst) {
    lastFocus = doc.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); doc.documentElement.classList.add('lp2-lock');
    setTimeout(function () { panel.focus(); }, 30);
    if (fetchFirst || !cart) refresh();
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); doc.documentElement.classList.remove('lp2-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]'); if (q) { var li = q.closest('[data-key]'); change(li.dataset.key, +q.dataset.q); return; }
    var a = e.target.closest('[data-add]'); if (a) { add(a.dataset.add, a.hasAttribute('data-gift')); return; }
    var x = e.target.closest('[data-c-close]'); if (x) { if (x.tagName === 'A' && x.getAttribute('href') === '#box') { e.preventDefault(); close(); var b = doc.getElementById('box'); b && b.scrollIntoView({ behavior: 'smooth' }); } else close(); }
  });
  doc.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = $$('a[href],button:not([disabled])', panel).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  // Any /cart link on the page opens the drawer instead
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"],[data-lp2-cart]'); if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopPropagation(); open(true);
  }, true);

  window.LP2Cart = { open: open, close: close, refresh: refresh };
  refresh();
})();
